<div class="side-menu-container">
  <div class="main-side-menu-background">
    <div class="main-side-menu">
      <div class="logo-text-container" (click)="navigateToHome()">
        <div class="logo-container">
          <img [src]="'images/browsi-logo.png' | assetVersion">
        </div>
        <div class="text-container">
          InsightHub
        </div>
      </div>

      <div class="menu-items" #menuItemsRef (scroll)="onMenuScroll()">
        @for (item of topItems; track item.route) {
          @if (item.badge) {
            <div class="side-menu-button copilot"
              [ngClass]="{ 'active-route': isActiveRoute(item.route), 'permission-disabled': item.disable }"
              (mouseenter)="(isCopilotHovered = true)" (mouseleave)="(isCopilotHovered = false)"
              (click)="navigateIfEnabled(item.route)">
              @if (item.disable) {
                <app-coming-soon class="coming-soon-tooltip" [isVisible]="isCopilotHovered" />
              }
              <img [src]="item.icon | assetVersion">
              <span>{{ item.text }}</span>
              <div class="copilot-beta">
                <span>{{ item.badge }}</span>
              </div>
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="flatItemTemplate; context: { config: item }"></ng-container>
          }
        }

        @for (category of categories; track category.label) {
          <div class="divider"></div>
          <div class="section-label">{{ category.label }}</div>

          @if (category.groups) {
            @for (group of category.groups; track group.id) {
              <div class="group-header"
                [ngClass]="{ 'coming-soon': group.comingSoon }"
                (click)="toggleGroup(group)"
                (mouseenter)="(hoveredMap[group.id] = true)"
                (mouseleave)="(hoveredMap[group.id] = false)"
                [tp]="group.premiumBadge && !group.comingSoon ? PremiumTooltipTemplate : null" [tpClassName]="'custom-tooltip'" [tpPlacement]="'bottom'">
                <div class="group-header-left">
                  <img [src]="group.icon | assetVersion">
                  <span>{{ group.text }}</span>
                </div>
                <div class="group-header-right">
                  @if (group.premiumBadge) {
                    <img [src]="'svg/premium-badge.svg' | assetVersion" class="premium-badge">
                  }
                  @if (group.collapsible) {
                    <img [src]="'svg/chevron-right.svg' | assetVersion"
                      class="chevron"
                      [ngClass]="{ 'expanded': group.expanded }">
                  }
                </div>
                @if (group.comingSoon) {
                  <app-coming-soon class="coming-soon-tooltip" [isVisible]="hoveredMap[group.id]" />
                }
              </div>
              @if (group.expanded) {
                @for (item of group.items; track item.text) {
                  <div class="group-item"
                    [ngClass]="{ 'active-route': isActiveRoute(item.route), 'permission-disabled': item.disable, 'coming-soon': item.comingSoon }"
                    (mouseenter)="(hoveredMap[group.id + '-' + item.text] = true)"
                    (mouseleave)="(hoveredMap[group.id + '-' + item.text] = false)"
                    (click)="navigateIfEnabled(item.route)">
                    <span>{{ item.text }}</span>
                    @if (item.comingSoon) {
                      <app-coming-soon class="coming-soon-tooltip" [isVisible]="hoveredMap[group.id + '-' + item.text]" />
                    }
                  </div>
                }
              }
            }
          }

          @if (category.items) {
            @for (item of category.items; track item.route) {
              <ng-container *ngTemplateOutlet="flatItemTemplate; context: { config: item }"></ng-container>
            }
          }
        }
      </div>

      <div class="scroll-gradient" [ngClass]="{ 'visible': showScrollGradient }"></div>

      @if (userGivenName && userFamilyName) {
      <div data-testid="sidebar-user-menu-button" class="side-menu-button user" #trigger="cdkOverlayOrigin"
        cdkOverlayOrigin (click)="openProfileScreen()">
        <img [src]="'svg/user-circle.svg' | assetVersion">
        <div class="user-name">
          {{ userGivenName }}
          <br>
          {{ userFamilyName }}
        </div>
      </div>
      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isProfileOpen"
        [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'transparent-backdrop'"
        [cdkConnectedOverlayPositions]="profilePositions" (backdropClick)="isProfileOpen = false"
        (overlayKeydown)="onKeyDown($event)">
        <app-profile (manageAccountsClicked)="navigate(RoutePaths.MANAGE)"></app-profile>
      </ng-template>
      }
    </div>
  </div>
</div>

<ng-template #flatItemTemplate let-config="config">
  <div
    class="side-menu-button"
    [ngClass]="{ 'active-route': isActiveRoute(config.route), 'permission-disabled': config.disable, 'coming-soon': config.comingSoon }"
    (mouseenter)="(hoveredMap[config.route] = true)"
    (mouseleave)="(hoveredMap[config.route] = false)"
    (click)="navigateIfEnabled(config.route)"
    [tp]="config.premiumBadge ? PremiumTooltipTemplate : null" [tpClassName]="'custom-tooltip'" [tpPlacement]="'bottom'">
    <img [src]="config.icon | assetVersion">
    <span>{{ config.text }}</span>
    @if (config.premiumBadge) {
      <img [src]="'svg/premium-badge.svg' | assetVersion" class="premium-badge">
    }
    @if (config.comingSoon) {
      <app-coming-soon class="coming-soon-tooltip" [isVisible]="hoveredMap[config.route]" />
    }
  </div>
</ng-template>

<ng-template #PremiumTooltipTemplate>
  <app-premium-tooltip [text]="tooltips.premium.sideMenuTab" [width]="'258px'"></app-premium-tooltip>
</ng-template>
